export default __webpack_public_path__ + "static/media/img-0204-columbia-half-face.75300803.png";